import React from "react"
import { __ } from "src/libs/utilities" 
import { festSatuses } from '../data/festStatuses'
import { FEST_ADMIN_STATUSES, IFestival } from "../data/interfaces"
import { IFestDataStor, useFestDataStore } from "../data/store"
  
interface IPahseLabelProps {
	phase?: FEST_ADMIN_STATUSES | undefined,
	className?: string
}
const PhaseLabel = (props: IPahseLabelProps) : JSX.Element => { 
	const festival : IFestival = useFestDataStore((state:IFestDataStor) => state.festival)
	const phase : FEST_ADMIN_STATUSES = ( props.phase ? props.phase : festival.status ) || FEST_ADMIN_STATUSES.BEFORE_START_PHASE 
	return <div className={`status-descr mr-md-auto ml-md-0 mx-auto ${ props.className || "" } `}>
			{ __( festSatuses()[ phase ]?.title ) }
		</div>
} 

export default PhaseLabel
	  
